export default {
  white: '#fff',
  black: '#000',
  green: '#38A36A',
  greenShadow: 'hsla(148, 49%, 43%, 0.6)',
  green1: '#EAF7F0',
  red: '#F85400',

  green2: '#107c44',
  green4: '#45b77b',
  green5: '#73c99c',

  green3: '#16a55a',

  blue: '#166cd3',
  blue1: '#10519e',
  blue2: '#4589dc',
  blue3: '#73a7e5',
  blue4: '#085ED0',

  grey1: '#3C4142',
  grey2: '#6D7475',
  grey3: '#899092',
  grey4: '#A5AEB0',
  grey5: '#CFD6D7',
  grey5Light: 'hsla(188, 9%, 83%, 0.6)',
  grey6: '#EEF1F2',
  grey6Light: 'hsla(195, 13%, 98%, 1)',
  darkerGrey6: 'hsla(195, 13%, 80%, 1)',
  grey7: '#E1E1E1',
  grey8: '#A0A0A0',

  grey9: '#6D7475',
  grey10: '#D3D5D5',
  grey11: '#595D5E',
  grey11transparent: 'hsla(192, 3%, 36%, 0.9)',
  grey12: '#C9D0D3',
  grey13: '#D9DBDB',
  grey14: '#F5F7F6',
  darkerGrey14: 'hsla(150, 11%, 90%, 1)',
  grey15: '#ECECEC',
  grey16: '#A5A5A5',

  yellow: '#F7BD38',
  orange: '#E66426',
  lightBlue: '#B0E8E4',
}
